const changeBasketAmount = () => {
    const basketCart = document.querySelector('.cart__products');
    if (!basketCart) {
        return;
    }
    ;
    const inputs = basketCart.querySelectorAll('.field__amount');
    const changeAmountHandler = (event) => {
        const input = event.target;
        changeAmount(input);
    };
    inputs && inputs.forEach(input => {
        input.addEventListener('change', changeAmountHandler);
    });
};
const changeAmount = (input) => {
    const itemId = input.dataset.id;
    const value = input.value;
    let optionsText = '';
    const product = input.closest('.cart__product');
    if (product) {
        const options = product.querySelectorAll('.cart__product__options__option');
        options && options.forEach(option => {
            optionsText += `&${option.dataset.option}`;
        });
    }
    const link = `/emarket/basket/put/element/${itemId}/?amount=${value}${optionsText}`;
    document.location = link;
};
export { changeBasketAmount, changeAmount };
